import { render, staticRenderFns } from "./agent-capability-picker.vue?vue&type=template&id=58b0c627&scoped=true"
import script from "./agent-capability-picker.vue?vue&type=script&lang=js"
export * from "./agent-capability-picker.vue?vue&type=script&lang=js"
import style0 from "./agent-capability-picker.vue?vue&type=style&index=0&id=58b0c627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b0c627",
  null
  
)

export default component.exports